import * as React from 'react';
import { Button, Form, FormGroup, Label } from '../../../../components/Bootstrap';
import { AddItemRow } from './AddItemRow';
import { Select } from '../../../../components';
import { SharedItems_sharedItems as BasicItem } from './__generated__/SharedItems';

interface AddItemModalProps {
  items: BasicItem[];
  allowAddingNew: boolean;
  onCancel();
  onSave(item: BasicItem | null);
}

const getValue = (state) => {
  if (state === null) {
    return 'Select item';
  } else if (state === 'add') {
    return 'Add a new item';
  }

  return state.name;
};

export const AddItemModalContent: React.FC<AddItemModalProps> = (props) => {
  const { onSave, items, allowAddingNew, onCancel } = props;

  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<null | 'add' | BasicItem>(null);

  const onSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
      if (selected) {
        const value = selected === 'add' ? null : selected;
        onSave(value);
      }
    },
    [selected, onSave]
  );

  const handleDropdownOpen = React.useCallback(() => {
    setDropdownOpen(true);
  }, [setDropdownOpen]);

  const handleDropdownClose = React.useCallback(() => {
    setDropdownOpen(false);
  }, [setDropdownOpen]);

  const handleSelectAddNewItem = React.useCallback(() => {
    setSelected('add');
    setDropdownOpen(false);
  }, [setDropdownOpen]);

  const handleSelectItem = React.useCallback(
    (item: BasicItem) => {
      setSelected(item);
      setDropdownOpen(false);
    },
    [setDropdownOpen]
  );

  const getScrollOffsetForLetter = () => {
    return 0;
  };

  const selectProps = {
    value: getValue(selected),
    open: dropdownOpen,
    getScrollOffsetForLetter,
    onOpen: handleDropdownOpen,
    onClose: handleDropdownClose,
  };

  return (
    <Form onSubmit={onSubmit}>
      <p className='text-center'>Select an item from our repository or choose ‘add a new item’ from the drop down.</p>
      <FormGroup className='add-item-modal-select-row'>
        <Label>Select an Item</Label>
        <Select {...selectProps}>
          <Select.Row>Select Item</Select.Row>
          {allowAddingNew && <Select.Row onClick={handleSelectAddNewItem}>Add a new item</Select.Row>}
          {items.length > 0 && <Select.Separator />}
          {items.map((item) => (
            <AddItemRow item={item} onSelect={handleSelectItem} key={item.id} />
          ))}
        </Select>
      </FormGroup>
      <div className='mt-5 text-center'>
        <Button onClick={onCancel} color='link'>
          Cancel
        </Button>
        <Button className='ms-2 ps-3 pe-3' type='submit' color='primary'>
          Add
        </Button>
      </div>
    </Form>
  );
};
